import React, { type ComponentPropsWithoutRef, useState } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { OptionHorizontalIcon } from '@/icons';
import { Drawer, DrawerContent, DrawerTrigger, IconButton } from '@/ui_v3';
import { cn } from '@/utils';
export const EditToolsDrawer = ({
  disabled,
  tools
}: {
  disabled?: boolean;
  tools: {
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
  }[];
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <Drawer open={isOpen} onOpenChange={setIsOpen} dismissible data-sentry-element="Drawer" data-sentry-component="EditToolsDrawer" data-sentry-source-file="EditToolsDrawer.tsx">
      <DrawerTrigger asChild disabled={disabled} data-sentry-element="DrawerTrigger" data-sentry-source-file="EditToolsDrawer.tsx">
        <IconButton size="xs" variant="outlined" intent="neutral" className="flex mobile-lg:hidden" data-sentry-element="IconButton" data-sentry-source-file="EditToolsDrawer.tsx">
          <OptionHorizontalIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} data-sentry-element="OptionHorizontalIcon" data-sentry-source-file="EditToolsDrawer.tsx" />
        </IconButton>
      </DrawerTrigger>
      <DrawerContent className="w-full px-md pb-lg" hasDrawerHandle onDimClick={() => setIsOpen(false)} hasDim={true} data-sentry-element="DrawerContent" data-sentry-source-file="EditToolsDrawer.tsx">
        {tools.map(tool => <EditToolsDrawerItem key={tool.label} onClick={() => {
        tool.onClick();
        setIsOpen(false);
      }}>
            {tool.icon}
            {tool.label}
          </EditToolsDrawerItem>)}
      </DrawerContent>
    </Drawer>;
};
const EditToolsDrawerItem = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('flex flex-row gap-xs px-2xs py-[13.5px] text-body-lg-medium cursor-pointer items-center', className)} {...props} data-sentry-component="EditToolsDrawerItem" data-sentry-source-file="EditToolsDrawer.tsx">
      {children}
    </div>;
};